import { render, staticRenderFns } from "./QuickReplyDialog.vue?vue&type=template&id=597d565c&scoped=true"
import script from "./QuickReplyDialog.vue?vue&type=script&lang=js"
export * from "./QuickReplyDialog.vue?vue&type=script&lang=js"
import style0 from "./QuickReplyDialog.vue?vue&type=style&index=0&id=597d565c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597d565c",
  null
  
)

export default component.exports